module.exports = __webpack_public_path__ + "static/img/info-center.e131ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/abouts/info-center.jpg
// module id = jO1b
// module chunks = 1